<form class="pb-4" [formGroup]="form">

  <!-- Primary Information Section -->
  <div class="form-section">
    <div class="collapsible-section" [class.is-expanded]="primaryInfoExpanded">
      <button type="button" class="collapsible-header"
        (click)="primaryInfoExpanded = !primaryInfoExpanded"
        [attr.aria-expanded]="primaryInfoExpanded">
        <span class="collapsible-header-title">Primary Information</span>
        <span class="collapsible-chevron" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </button>
      <div class="collapsible-content">
        <div class="collapsible-content-inner">
          <div class="flex gap-2 items-start">
            <div class="flex-1">
              <app-dynamic-form
                [gridSize]="6"
                [viewMode]="true"
                [formGroup]="form"
                [data]="primaryInfoFields">
              </app-dynamic-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CREATE MODE -->
  <ng-container *ngIf="mode === 'create'">

    <!-- Available Assets Section -->
    <div class="form-section">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Available Assets (Assign Existing)</p-accordion-header>
          <p-accordion-content>
            <div class="card rounded-lg bg-[#fafbfc]">
              <p-table [value]="availableAssetRows" [tableStyle]="{ 'min-width': '100%' }" [size]="'small'">
                <ng-template #header>
                  <tr>
                    <th style="width: 3rem">#</th>
                    <th>Asset </th>
                    <th>Assign To Department</th>
                    <th>Assign To Person</th>
                    <th style="width: 8rem">Actions</th>
                  </tr>
                </ng-template>
                <ng-template #body let-row let-i="rowIndex">
                  <tr>
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>
                      <p-autocomplete
                        size="small"
                        fluid
                        [(ngModel)]="row.asset"
                        [ngModelOptions]="{standalone: true}"
                        [suggestions]="row.assetSuggestions"
                        (completeMethod)="searchAvailableAssets($event, row)"
                        optionLabel="label"
                        placeholder="Search asset..."
                        [forceSelection]="true"
                        [dropdown]="true"
                        appendTo="body" />
                    </td>
                    <td>
                      <p-autocomplete
                        size="small"
                        fluid
                        [(ngModel)]="row.assignToDepartment"
                        [ngModelOptions]="{standalone: true}"
                        [suggestions]="row.departmentSuggestions"
                        (completeMethod)="searchAvailableDepartments($event, row)"
                        optionLabel="label"
                        placeholder="Search department..."
                        [forceSelection]="true"
                        [dropdown]="true"
                        appendTo="body" />
                    </td>
                    <td>
                      <p-autocomplete
                        size="small"
                        fluid
                        [(ngModel)]="row.assignToPerson"
                        [ngModelOptions]="{standalone: true}"
                        [suggestions]="row.userSuggestions"
                        (completeMethod)="searchUsers($event, row)"
                        optionLabel="label"
                        placeholder="Search user..."
                        [forceSelection]="true"
                        [dropdown]="true"
                        appendTo="body" />
                    </td>
                    <td>
                      <div class="flex gap-1">
                        <p-button
                          icon="pi pi-eye"
                          [rounded]="true"
                          [text]="true"
                          severity="info"
                          (onClick)="toggleAvailableAssetExpand(i)"
                          pTooltip="View Asset Details" />
                        <p-button
                          icon="pi pi-times"
                          [rounded]="true"
                          [text]="true"
                          severity="danger"
                          (onClick)="removeAvailableAssetRow(i)"
                          pTooltip="Remove" />
                      </div>
                    </td>
                  </tr>
                  <!-- Expanded asset details -->
                  <tr *ngIf="row.expanded && row.asset">
                    <td colspan="5">
                      <div class="expanded-detail p-3 bg-gray-50 rounded">
                        <div style="display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 1rem;">
                          <div style="grid-column: span 2">
                            <label class="font-semibold text-sm mb-2">Asset Code</label>
                            <div class="text-sm rounded min-h-[12px] flex items-center">{{ row.asset.asset_code || '-' }}</div>
                          </div>
                          <div style="grid-column: span 2">
                            <label class="font-semibold text-sm mb-2">Asset Name</label>
                            <div class="text-sm rounded min-h-[12px] flex items-center">{{ row.asset.asset_name || '-' }}</div>
                          </div>
                          <div style="grid-column: span 2">
                            <label class="font-semibold text-sm mb-2">Serial Number</label>
                            <div class="text-sm rounded min-h-[12px] flex items-center">{{ row.asset.serial_number || '-' }}</div>
                          </div>
                          <div style="grid-column: span 2">
                            <label class="font-semibold text-sm mb-2">Status</label>
                            <div class="text-sm rounded min-h-[12px] flex items-center">{{ row.asset.status || '-' }}</div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="5" class="text-center text-gray-400 py-4">
                      No assets added yet.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <!-- Not Available Assets Section -->
    <div class="form-section">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Not Available Assets (Purchase / Transfer)</p-accordion-header>
          <p-accordion-content>
            <div class="card rounded-lg bg-[#fafbfc]">
              <p-table [value]="notAvailableAssetRows" [tableStyle]="{ 'min-width': '100%' }" [size]="'small'">
                <ng-template #header>
                  <tr>
                    <th style="width: 3rem">#</th>
                    <th>Fulfillment Type</th>
                    <th>Asset</th>
                    <th style="width: 6rem">Quantity</th>
                    <th style="width: 8rem">
                      <div class="flex items-center justify-between">
                        <span>Actions</span>
                        <p-button icon="pi pi-plus" [rounded]="true" [text]="true" severity="secondary"
                          (onClick)="addNotAvailableAssetRow()" pTooltip="Add Row" [style]="{'height': '1.5rem', 'width': '1.5rem'}" />
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-row let-i="rowIndex">
                  <tr>
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>
                      <p-select
                        size="small"
                        fluid
                        [(ngModel)]="row.fulfillmentType"
                        [ngModelOptions]="{standalone: true}"
                        [options]="fulfillmentTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select type"
                        (onChange)="onFulfillmentTypeChanged(row)"
                        appendTo="body" />
                    </td>
                    <td>
                      <p-autocomplete
                        *ngIf="row.fulfillmentType === 'transfer'"
                        size="small"
                        fluid
                        [(ngModel)]="row.asset"
                        [ngModelOptions]="{standalone: true}"
                        [suggestions]="row.assetSuggestions"
                        (completeMethod)="searchTransferAssets($event, row)"
                        (onSelect)="onTransferAssetSelected(row)"
                        optionLabel="label"
                        placeholder="Search asset..."
                        [forceSelection]="true"
                        [dropdown]="true"
                        appendTo="body" />
                      <p-autocomplete
                        *ngIf="row.fulfillmentType === 'procurement'"
                        size="small"
                        fluid
                        [(ngModel)]="row.itemMaster"
                        [ngModelOptions]="{standalone: true}"
                        [suggestions]="row.itemMasterSuggestions"
                        (completeMethod)="searchProcurementItems($event, row)"
                        (onSelect)="onProcurementItemSelected(row)"
                        optionLabel="label"
                        placeholder="Search asset..."
                        [forceSelection]="true"
                        [dropdown]="true"
                        appendTo="body" />
                      <span *ngIf="row.fulfillmentType !== 'transfer' && row.fulfillmentType !== 'procurement'" class="text-sm text-gray-400">N/A</span>
                    </td>
                    <td>
                      <p-inputNumber
                        *ngIf="row.fulfillmentType === 'procurement'"
                        size="small"
                        fluid
                        [(ngModel)]="row.quantity"
                        [ngModelOptions]="{standalone: true}"
                        [min]="1"
                        [max]="getRemainingQuantity()"
                        [showButtons]="true" />
                      <span *ngIf="row.fulfillmentType !== 'procurement'" class="text-sm">1</span>
                    </td>
                    <td>
                      <div class="flex gap-1">
                        <p-button
                          *ngIf="row.fulfillmentType === 'transfer'"
                          icon="pi pi-chevron-down"
                          [rounded]="true"
                          [text]="true"
                          severity="info"
                          (onClick)="toggleNotAvailableAssetExpand(i)"
                          pTooltip="Transfer Details" />
                        <p-button
                          icon="pi pi-times"
                          [rounded]="true"
                          [text]="true"
                          severity="danger"
                          (onClick)="removeNotAvailableAssetRow(i)"
                          pTooltip="Remove" />
                      </div>
                    </td>
                  </tr>
                  <!-- Expanded Transfer Details -->
                  <tr *ngIf="row.expanded && row.fulfillmentType === 'transfer'">
                    <td colspan="5">
                      <div class="expanded-detail p-4 bg-gray-50 rounded">
                        <!-- Asset Information (read-only via DynamicForm) -->
                        <h5 class="mb-4 font-semibold">Asset Information</h5>
                        <app-dynamic-form
                          [gridSize]="6"
                          [viewMode]="true"
                          [formGroup]="row.transferForm"
                          [data]="transferAssetInfoFields">
                        </app-dynamic-form>

                        <!-- Transfer Details -->
                        <h5 class="mb-4 mt-6 font-semibold">Transfer Details</h5>
                        <!-- Target subsidiary/location pre-filled from asset request (read-only) -->
                        <div style="display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 1rem;" class="mb-4">
                          <div class="form-field" style="grid-column: span 1">
                            <label class="font-semibold text-sm mb-2">Target Subsidiary</label>
                            <p-select
                              size="small"
                              fluid
                              [(ngModel)]="row.transferTargetSubsidiary"
                              [ngModelOptions]="{standalone: true}"
                              [options]="subsidiaryOptions"
                              optionLabel="label"
                              placeholder="Select subsidiary"
                              [disabled]="true"
                              [appendTo]="'body'" />
                          </div>
                          <div class="form-field" style="grid-column: span 1">
                            <label class="font-semibold text-sm mb-2">Target Location</label>
                            <p-select
                              size="small"
                              fluid
                              [(ngModel)]="row.transferTargetLocation"
                              [ngModelOptions]="{standalone: true}"
                              [options]="row.targetLocationOptions"
                              optionLabel="label"
                              placeholder="Select location"
                              [disabled]="true"
                              [appendTo]="'body'" />
                          </div>
                        </div>
                        <!-- Remaining transfer details via DynamicForm -->
                        <app-dynamic-form
                          [gridSize]="6"
                          [formGroup]="row.transferForm"
                          [data]="transferDetailFields">
                        </app-dynamic-form>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="5" class="text-center text-gray-400 py-4">
                      No entries added yet.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <!-- Action Buttons -->
    <div class="save-container">
      <div class="flex items-center gap-3">
        <p-button
          label="Cancel"
          severity="secondary"
          [outlined]="true"
          (onClick)="onCancel()" />
        <p-button
          label="Save"
          (onClick)="onSave()"
          [loading]="isSubmitting"
          [disabled]="isSubmitting" />
      </div>
    </div>
  </ng-container>

  <!-- VIEW MODE (read-only) -->
  <ng-container *ngIf="mode === 'view'">
    <div class="form-section">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Fulfillment Details</p-accordion-header>
          <p-accordion-content>
            <div class="card rounded-lg bg-[#fafbfc] overflow-x-auto">
              <p-table [value]="fulfillments" [tableStyle]="{ 'min-width': '100%' }" [size]="'small'">
                <ng-template #header>
                  <tr>
                    <th>Asset</th>
                    <th>Fulfillment Type</th>
                    <th>Qty</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th>Fulfilled By</th>
                    <th>Created At</th>
                    <th>Remarks</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template #body let-f>
                  <tr>
                    <td><span class="text-sm">{{ f.asset_code }} {{ f.asset_code ? '- ' + f.asset_name : f.asset_name ? f.asset_name : '-' }}</span></td>
                    <td><span class="text-sm">{{ formatFulfillmentType(f.fulfillment_type) }}</span></td>
                    <td><span class="text-sm">{{ f.quantity }}</span></td>
                    <td>
                      <span class="text-sm" *ngIf="f.fulfillment_type === 'transfer'">{{ f.transfer_no || '-' }}</span>
                      <span class="text-sm" *ngIf="f.fulfillment_type === 'procurement'">{{ f.grn_receipt_no || '-' }}</span>
                      <span class="text-sm" *ngIf="f.fulfillment_type === 'inventory'">-</span>
                    </td>
                    <td>
                      <p-tag
                        [value]="getStatusLabel(f)"
                        [severity]="getStatusSeverity(f.status)" />
                    </td>
                    <td><span class="text-sm">{{ f.fulfilled_by_name || '-' }}</span></td>
                    <td><span class="text-sm">{{ f.created_at | date:'dd/MM/yyyy' }}</span></td>
                    <td><span class="text-sm">{{ f.remarks || '-' }}</span></td>
                    <td>
                      <span
                        *ngIf="hasExistingAssignments(f)"
                        class="view-assignment-link"
                        (click)="toggleFulfillmentExpand('' + f.id)">
                        {{ f.fulfillment_type === 'inventory' ? 'View Asset Details' : 'View Assignment Details' }}
                        <i [class]="isFulfillmentExpanded('' + f.id) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" style="font-size: 0.75rem; margin-left: 0.25rem;"></i>
                      </span>
                    </td>
                  </tr>
                  <!-- Expanded Assignment Sub-rows (read-only) -->
                  <tr [hidden]="!isFulfillmentExpanded('' + f.id)" class="assignment-expand-row">
                    <td colspan="9" style="padding: 0;">
                      <div class="assignment-panel">
                        <!-- Assignment Table for non-inventory -->
                        <table class="assignment-table" *ngIf="f.fulfillment_type !== 'inventory'">
                          <thead>
                            <tr>
                              <th>Asset Name</th>
                              <th>Serial No.</th>
                              <th>Model No.</th>
                              <th>Department</th>
                              <th>Assigned To</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of getAssignments('' + f.id)" [hidden]="!row.isExisting">
                              <td><span class="text-sm">{{ row.asset_name || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.serial_number || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.model_no || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.assignedDepartment?.label || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.assignedUser?.label || '-' }}</span></td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Asset Detail Section for inventory -->
                        <div class="asset-detail-section" *ngIf="f.fulfillment_type === 'inventory'">
                          <div *ngIf="getFulfillmentAssetDetails('' + f.id) as details; else loadingAsset">
                            <!-- Header row: Description label + View History link -->
                            <div class="asset-section-header">
                              <span class="asset-section-title">Description</span>
                              <a class="view-history-link" (click)="viewAssetHistory(f.asset_id)">View History</a>
                            </div>

                            <!-- Full-width description text -->
                            <p class="asset-description-text">{{ details.description || '-' }}</p>

                            <!-- Row 1: Serial No., Asset Tag, Asset Group, Asset Sub-Group, Asset Type -->
                            <div class="asset-fields-grid">
                              <div class="asset-field">
                                <label>Serial No.</label>
                                <p>{{ details.serial_number || '-' }}</p>
                              </div>
                              <div class="asset-field">
                                <label>Asset Tag</label>
                                <p>{{ details.barcode || details.tag_prefix || '-' }}</p>
                              </div>
                              <div class="asset-field">
                                <label>Asset Group</label>
                                <p>{{ details.asset_group_name || '-' }}</p>
                              </div>
                              <div class="asset-field">
                                <label>Asset Sub-Group</label>
                                <p>{{ details.asset_sub_group_name || '-' }}</p>
                              </div>
                              <div class="asset-field">
                                <label>Asset Type</label>
                                <p>{{ details.asset_type || '-' }}</p>
                              </div>
                            </div>

                            <!-- Row 2: Location, Center -->
                            <div class="asset-fields-grid">
                              <div class="asset-field">
                                <label>Location</label>
                                <p>{{ details.location_name || '-' }}</p>
                              </div>
                              <div class="asset-field">
                                <label>Center</label>
                                <p>{{ details.subsidiary_name || '-' }}</p>
                              </div>
                            </div>
                          </div>
                          <ng-template #loadingAsset>
                            <div class="p-4 text-center text-gray-400">
                              <i class="pi pi-spin pi-spinner mr-2"></i> Loading asset details...
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="9" class="text-center text-gray-400 py-4">
                      No fulfillments found for this item.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <div class="save-container">
      <p-button
        label="Back"
        severity="secondary"
        [outlined]="true"
        (onClick)="onCancel()" />
    </div>
  </ng-container>

  <!-- EDIT MODE -->
  <ng-container *ngIf="mode === 'edit'">
    <div class="form-section">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Fulfillment Details</p-accordion-header>
          <p-accordion-content>
            <div class="card rounded-lg bg-[#fafbfc] overflow-x-auto">
              <p-table [value]="fulfillments" [tableStyle]="{ 'min-width': '100%' }" [size]="'small'">
                <ng-template #header>
                  <tr>
                    <th>Asset</th>
                    <th>Fulfillment Type</th>
                    <th>Qty</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th>Fulfilled By</th>
                    <th>Created At</th>
                    <th>Remarks</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template #body let-f>
                  <tr>
                    <td><span class="text-sm">{{ f.asset_code }} {{ f.asset_code ? '- ' + f.asset_name : f.asset_name ? f.asset_name : '-' }}</span></td>
                    <td><span class="text-sm">{{ formatFulfillmentType(f.fulfillment_type) }}</span></td>
                    <td><span class="text-sm">{{ f.quantity }}</span></td>
                    <td>
                      <span class="text-sm" *ngIf="f.fulfillment_type === 'transfer'">{{ f.transfer_no || '-' }}</span>
                      <span *ngIf="f.fulfillment_type === 'procurement'" class="flex items-center gap-1">
                        <span class="text-sm">{{ f.grn_receipt_no || '-' }}</span>
                        <p-button
                          *ngIf="f.grn_id"
                          icon="pi pi-file-edit"
                          [rounded]="true"
                          [text]="true"
                          severity="info"
                          (onClick)="openGrnAssetsModal(f)"
                          pTooltip="Select GRN Assets"
                          [style]="{'height': '1.5rem', 'width': '1.5rem'}" />
                      </span>
                      <span class="text-sm" *ngIf="f.fulfillment_type === 'inventory'">-</span>
                    </td>
                    <td>
                      <p-tag
                        [value]="getStatusLabel(f)"
                        [severity]="getStatusSeverity(f.status)" />
                    </td>
                    <td><span class="text-sm">{{ f.fulfilled_by_name || '-' }}</span></td>
                    <td><span class="text-sm">{{ f.created_at | date:'dd/MM/yyyy' }}</span></td>
                    <td><span class="text-sm">{{ f.remarks || '-' }}</span></td>
                    <td>
                      <span
                        *ngIf="hasAssignments('' + f.id)"
                        class="view-assignment-link"
                        (click)="toggleFulfillmentExpand('' + f.id)">
                        View Assignment Details
                        <i [class]="isFulfillmentExpanded('' + f.id) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" style="font-size: 0.75rem; margin-left: 0.25rem;"></i>
                      </span>
                    </td>
                  </tr>
                  <!-- Expanded Assignment Sub-rows (editable) -->
                  <tr [hidden]="!isFulfillmentExpanded('' + f.id)" class="assignment-expand-row">
                    <td colspan="9" style="padding: 0;">
                      <div class="assignment-panel">
                        <table class="assignment-table">
                          <thead>
                            <tr>
                              <th>Asset Code</th>
                              <th>Asset Name</th>
                              <th>Serial No.</th>
                              <th>Model No.</th>
                              <th>Assign to Department</th>
                              <th>Assign to Person</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of getAssignments('' + f.id)">
                              <td><span class="text-sm">{{ row.asset_code || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.asset_name || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.serial_number || '-' }}</span></td>
                              <td><span class="text-sm">{{ row.model_no || '-' }}</span></td>
                              <td>
                                <ng-container *ngIf="row.isExisting; else deptEdit">
                                  <span class="text-sm">{{ row.assignedDepartment?.label || '-' }}</span>
                                </ng-container>
                                <ng-template #deptEdit>
                                  <p-autoComplete
                                    [(ngModel)]="row.assignedDepartment"
                                    [ngModelOptions]="{standalone: true}"
                                    [suggestions]="row.departmentSuggestions"
                                    (completeMethod)="searchAssignmentDepartments($event, row)"
                                    field="label"
                                    placeholder="Search department..."
                                    [forceSelection]="true"
                                    [appendTo]="'body'"
                                    [style]="{'width': '100%'}"
                                    [inputStyle]="{'width': '100%', 'height': '2rem', 'font-size': '0.8125rem'}" />
                                </ng-template>
                              </td>
                              <td>
                                <ng-container *ngIf="row.isExisting; else userEdit">
                                  <span class="text-sm">{{ row.assignedUser?.label || '-' }}</span>
                                </ng-container>
                                <ng-template #userEdit>
                                  <p-autoComplete
                                    [(ngModel)]="row.assignedUser"
                                    [ngModelOptions]="{standalone: true}"
                                    [suggestions]="row.userSuggestions"
                                    (completeMethod)="searchAssignmentUsers($event, row)"
                                    field="label"
                                    placeholder="Search user..."
                                    [forceSelection]="true"
                                    [appendTo]="'body'"
                                    [style]="{'width': '100%'}"
                                    [inputStyle]="{'width': '100%', 'height': '2rem', 'font-size': '0.8125rem'}" />
                                </ng-template>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="9" class="text-center text-gray-400 py-4">
                      No fulfillments found for this item.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <div class="save-container">
      <p-button
        label="Back"
        severity="secondary"
        [outlined]="true"
        (onClick)="onCancel()" />
        
      <!-- Show when edit mode and assignments exist -->
      <ng-container *ngIf="mode === 'edit'">
        <p-button
          *ngIf="fulfillmentAssignments.size > 0 && hasNewAssignments()"
          label="Save All Assignments"
          icon="pi pi-save"
          (onClick)="saveAllAssignments()" />
      </ng-container>
    </div>
  </ng-container>

</form>

<!-- Loading state -->
<div *ngIf="isLoading" class="nf-overlay">
  <svg class="nf-spinner" viewBox="0 0 50 50">
    <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
    <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
  </svg>
</div>

<!-- GRN Assets Modal -->
<p-dialog
  header="Request No. {{ requestData?.request_no || '' }}"
  [(visible)]="showGrnAssetsModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: '60vw' }"
  styleClass="grn-assets-dialog">
  <div *ngIf="grnModalFulfillment">
    <!-- GRN Info Bar -->
    <div class="grn-info-bar">
      <div class="grn-info-item">
        <span class="grn-info-label">Select GRN</span>
        <span class="grn-info-value">{{ grnModalFulfillment.grn_receipt_no }}</span>
      </div>
      <div class="grn-info-item">
        <span class="grn-info-label">Quantity</span>
        <span class="grn-info-value">{{ grnModalFulfillment.quantity }}</span>
      </div>
    </div>

    <!-- Assets Table -->
    <div class="grn-assets-table-wrapper">
      <p-table
        [value]="grnAssets"
        [(selection)]="selectedGrnAssets"
        dataKey="id"
        [tableStyle]="{ 'min-width': '100%' }"
        styleClass="grn-assets-table">
        <ng-template #header>
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox />
            </th>
            <th>Asset Code</th>
            <th>Asset Name</th>
            <th>Serial No.</th>
            <th>Model No.</th>
          </tr>
        </ng-template>
        <ng-template #body let-asset>
          <tr>
            <td>
              <p-tableCheckbox [value]="asset" />
            </td>
            <td>{{ asset.asset_code || '-' }}</td>
            <td>{{ asset.asset_name || '-' }}</td>
            <td>{{ asset.serial_number || '-' }}</td>
            <td>{{ asset.model_no || '-' }}</td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="4" class="text-center" style="padding: 1.5rem; color: #94a3b8;">
              No assets found for this GRN.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Save Button -->
    <div class="grn-modal-footer">
      <p-button
        label="Save"
        (onClick)="onGrnAssetsSave()" />
    </div>
  </div>
</p-dialog>

<!-- Asset History Modal -->
<app-asset-history-modal
  [(visible)]="historyModalVisible"
  [assetId]="selectedAssetIdForHistory">
</app-asset-history-modal>
